
import { useEffect, useState } from "react";

/**
 * 
 * @param {any} value 
 * @param {number} delay
 * @returns 
 */
export default function useDebounce(value, delay = 500) {

    const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler); 
  }, [value, delay]);

  return debouncedValue;
}
